import { Box, Divider, GridLayout } from '@wishket/design-system';
import { Fragment } from 'react';

import { SERVICE_LIST } from './AppBar.constants';
import { ServiceLinkItem } from './parts/LinkItem';

const ServiceNavigationBar = () => {
  return (
    <Box
      data-testid="service-nav-root"
      className="flex h-9 w-full border-b border-w-gray-200 bg-w-white"
    >
      <GridLayout>
        <nav className="box-border flex items-center gap-3 grid-in-content">
          {SERVICE_LIST.map((item, index) => {
            const isLastItem = SERVICE_LIST.length - 1 === index;

            return (
              <Fragment key={index}>
                <ServiceLinkItem
                  name={item.name}
                  icon={item.icon}
                  href={item.href}
                  disabled={index !== 0}
                />
                {!isLastItem && <Divider isVertical className="h-3" />}
              </Fragment>
            );
          })}
        </nav>
      </GridLayout>
    </Box>
  );
};

export default ServiceNavigationBar;
